import moment from 'moment'

export const ServiceOrder = {
    id: '',
    serviceNo: '',
    date: moment().format('YYYY-MM-DD'),
    name: '',
    phoneNumber: '',
    email: '',
    serviceCode: '',
    serviceName: '',
    isConfirm: '',
    createdAt: ''
}